module.exports = __webpack_public_path__ + "static/media/espressomilanostyle.92de93fe.jpg";